import { fetchBrandCapabilities } from '@/features/hestia/queries/useBrandCapabilities'
import { FeatureFlags } from '@/plugins/featureFlags'
import type { HermesGuardFn } from '@/router/guards/types'
import { refreshFeatureFlagsForBrand } from '@/utils/refreshFeatureFlagsForBrand'

import { isWebsiteVariantBAvailable } from '../../websiteBuilderAvailability'

export const checkWebsiteDesignRoute: HermesGuardFn = async (to) => {
  if (to.name !== 'brand.website.design') return undefined

  const brandId = to.params.brandId
  const redirect = {
    name: 'brand.website.pages.home',
    params: { brandId },
  }

  if (typeof brandId !== 'string') {
    return redirect
  }

  await refreshFeatureFlagsForBrand(brandId)

  if (!FeatureFlags.isEnabled('hermes.websiteVariantBRoutes')) {
    return redirect
  }

  let capabilities: Awaited<ReturnType<typeof fetchBrandCapabilities>>
  try {
    capabilities = await fetchBrandCapabilities(brandId)
  } catch {
    return redirect
  }

  const capabilityActive =
    capabilities['website-builder']?.['website-builder']?.status === 'active'

  if (isWebsiteVariantBAvailable(FeatureFlags, capabilityActive)) {
    return undefined
  }

  return redirect
}
